import axios from "axios";
import { apiVariable } from "./apiVariable";
import { TruckComplianceMatrixDto } from "../interfaces/Fleet/TruckComplianceMatrixDto";

export const getTruckComplianceMatrix = async (token?: string) => {
  const { data } = await axios.get<TruckComplianceMatrixDto[]>(
    `${apiVariable}/getTruckComplianceMatrix`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return data;
};

export const getTruckComplianceMatrixByTruckId = async (
  truckId: string,
  token?: string,
) => {
  const { data } = await axios.get<TruckComplianceMatrixDto>(
    `${apiVariable}/getTruckComplianceMatrix/${truckId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  return data;
};
